import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MasterDataEditService } from '../../../../../api/master-data-edit.service';
import { AffectingProductData } from '../../../../../shared/models/product.model';

@Component({
  selector: 'app-rename-product',
  templateUrl: './rename-product.component.html',
})
export class RenameProductComponent implements OnInit {
  @ViewChild('existingProductNameGrid') existingProductNameGrid: DxDataGridComponent;

  public affectedEditProductNameData: AffectingProductData[] = [];
  public existingEditProductNameData: AffectingProductData[] = [];

  @Input() selectedEditProductOldName: string;
  @Input() selectedEditProductNewName: string;
  @Input() productId;

  private _destroyed$ = new Subject();

  constructor(private masterDataEditService: MasterDataEditService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
	this.masterDataEditService.getAffectingProductData(this.selectedEditProductOldName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingProductData[]) => {
		this.affectedEditProductNameData = res;
		});

	this.masterDataEditService.getExistingProductData(this.selectedEditProductNewName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingProductData[]) => {
		this.existingEditProductNameData = res;
		});
  }

  rename() {
	this.activeModal.close('save');
  }

  customizeProductId(cellInfo) {
	const idStr = 'Pr_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  valueChanged(event) {
	this.existingProductNameGrid.instance.beginCustomLoading('Loading');
	this.masterDataEditService.getExistingProductData(event.value)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingProductData[]) => {
		this.existingEditProductNameData = res;
		this.existingProductNameGrid.instance.option('dataSource', res);
		this.existingProductNameGrid.instance.endCustomLoading();
		});
  }

}
